"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachImageFormToJSON = exports.AttachImageFormFromJSONTyped = exports.AttachImageFormFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachImageFormFromJSON(json) {
    return AttachImageFormFromJSONTyped(json, false);
}
exports.AttachImageFormFromJSON = AttachImageFormFromJSON;
function AttachImageFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': json['file'],
        'fileName': !runtime_1.exists(json, 'fileName') ? undefined : json['fileName'],
        'side': !runtime_1.exists(json, 'side') ? undefined : _1.AttachmentSideModelFromJSON(json['side']),
        'lightSpectrum': !runtime_1.exists(json, 'lightSpectrum') ? undefined : _1.LightSpectrumFromJSON(json['lightSpectrum']),
    };
}
exports.AttachImageFormFromJSONTyped = AttachImageFormFromJSONTyped;
function AttachImageFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': value.file,
        'fileName': value.fileName,
        'side': _1.AttachmentSideModelToJSON(value.side),
        'lightSpectrum': _1.LightSpectrumToJSON(value.lightSpectrum),
    };
}
exports.AttachImageFormToJSON = AttachImageFormToJSON;
//# sourceMappingURL=AttachImageForm.js.map